import React, { useState } from 'react';
import { connect } from 'react-redux'
import { compose } from 'recompose';
import parseImagUrl from "../../../../components/Common/parseImagUrl";
import { withStyles, Typography, Card, CardContent, CardMedia } from '@material-ui/core';
import { withTranslation } from 'react-i18next'
import { openFullview } from '@tuqqi/web';
import groupPlaceholder from "../../../../../assets/img/group_placeholder.png";

const styles = theme => ({
    container2: {
        flexDirection: 'column',
        position: "relative",
        marginRight: 10,
        height: 474,
        maxWidth: 248,
        width: 248,
        borderRadius: 4,
        overflow: 'hidden',
        '&:last-child': {
            marginRight: 0
        },
        backgroundColor: '#fff',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14)'
    },

    img2: {
        width: '100%',
        height: 310,
    },
    content2: {
        backgroundColor: '#fff',
        padding: 0,
    },
    name2: {
        marginTop: 20,
        color: '#21212d',
        textAlign: 'center',
        fontStyle: 'normal',
        fontFamily: 'Rubik',
        fontWeight: 'normal',
        lineHeight: 'normal',
        fontStretch: 'normal',
        letterSpacing: 'normal',
        fontSize: 24,
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxHeight: 2,
        display: '-webkit-box',
        '-webkit-line-clamp': 1,
        '-webkit-box-orient': 'vertical',
        paddingRight: 10,
        paddingLeft: 10,
        paddingBottom: 25
    },
    subtitle: {
        margin: '8px 16px 16px',
        fontFamily: 'Rubik',
        fontSize: 12,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#a3a3a3',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxHeight: 55,
        '-webkit-line-clamp': 3,
        '-webkit-box-orient': 'vertical',
        display: '-webkit-box'
    },
    readMore: {
        cursor: 'pointer',
        fontFamily: 'Rubik',
        fontSize: 14,
        fontWeight: '500',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.29,
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#7d3deb',
        width: '100%',
        position: 'absolute',
        bottom: 20
    }
});

const MostTrendingItem = (props) => {
    const { classes, item, cloudfront, dispatch, t } = props;
    const [backgroundLink] = useState(parseImagUrl(cloudfront, item.backgroundImage, 500, groupPlaceholder))
    
    const onClickOpenDocument = () => {
        dispatch(openFullview(item.itemId, true))
    }
        return (
            <Card className={classes.container2} elevation={0}>
                <CardMedia className={classes.img2}
                    image={backgroundLink}
                    title={item.title} />
                <CardContent className={classes.content2}>
                    <Typography className={classes.name2}>{item.title}</Typography>
                    <Typography className={classes.subtitle}>{item.subtitle}</Typography>
                    <Typography onClick={onClickOpenDocument} className={classes.readMore}>{t('Read more')}</Typography>
                </CardContent>
            </Card>
        )
}

const mapStateToProps = (state) => ({
    cloudfront: state.globalData.cloudfront,
})


const mapDispatchToProps = dispatch => ({ dispatch })

export default compose(withStyles(styles, {withTheme: true}), withTranslation('library'),
    connect(mapStateToProps, mapDispatchToProps))(MostTrendingItem);
